import type { PricingTranslation } from './types'

export const pricingTranslationAr: PricingTranslation = {
  title: 'التسعير',
  description: 'إدارة التسعير في النظام',
  actions: {
    create: 'إنشاء سعر',
    edit: 'تعديل السعر',
    delete: 'حذف السعر',
    view: 'عرض السعر',
    save: 'حفظ',
    cancel: 'إلغاء',
  },
  form: {
    name: 'الاسم',
    description: 'الوصف',
    status: 'الحالة',
  },
  status: {
    active: 'نشط',
    inactive: 'غير نشط',
    pending: 'قيد الانتظار',
  },
  messages: {
    created: 'تم إنشاء السعر بنجاح',
    updated: 'تم تحديث السعر بنجاح',
    deleted: 'تم حذف السعر بنجاح',
    error: 'حدث خطأ',
  },
}
